import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Dropdown, Menu } from 'antd';
import { SignOut, User, GearSix } from '@phosphor-icons/react';
import Typography from '../../components/Typography';
import MedsenderIcon from '../../assets/img/redesign/medsender_icon.png';
import { logout } from '../../actions/auth';
import './portalTopBar.scss';

const PortalTopBar = ({
  user, onLogout, isAdmin, history,
}) => {
  const menu = (
    <Menu>
      {isAdmin && (
        <Menu.Item key="settings" onClick={() => history.push('/app/referral_portal/settings')}>
          <GearSix size={16} style={{ marginRight: 8 }} />
          Settings
        </Menu.Item>
      )}
      <Menu.Item key="logout" onClick={onLogout}>
        <SignOut size={16} style={{ marginRight: 8 }} />
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="portal-topbar">
      <div className="portal-topbar__left">
        <img src={MedsenderIcon} width="30px" alt="Medsender" />
      </div>
      <div className="portal-topbar__right">
        <Dropdown overlay={menu} trigger={['click']}>
          <div className="portal-topbar__user">
            <div className="portal-topbar__avatar">
              {user?.fullName?.charAt(0) || <User size={16} />}
            </div>
            <div className="portal-topbar__user-info">
              <Typography variant="text" size="small" bold>
                {user?.fullName || 'User'}
              </Typography>
              <Typography variant="text" size="xsmall" className="portal-topbar__user-org">
                {user?.organization || ''}
              </Typography>
            </div>
          </div>
        </Dropdown>
      </div>
    </div>
  );
};

PortalTopBar.propTypes = {
  user: PropTypes.object,
  onLogout: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool,
  history: PropTypes.object.isRequired,
};

PortalTopBar.defaultProps = {
  user: null,
  isAdmin: false,
};

export default withRouter(connect((state) => ({
  user: state.auth.data,
  isAdmin: state.auth.isAdmin,
}), { onLogout: logout })(PortalTopBar));
